module.exports = __webpack_public_path__ + "static/media/agripreneurs_img2.17f0ac6c.webp";